import { render, staticRenderFns } from "./flightsGrid.vue?vue&type=template&id=1c1c2bcb&scoped=true&"
import script from "./flightsGrid.vue?vue&type=script&lang=js&"
export * from "./flightsGrid.vue?vue&type=script&lang=js&"
import style0 from "./flightsGrid.vue?vue&type=style&index=0&id=1c1c2bcb&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c1c2bcb",
  null
  
)

export default component.exports